
import Vue from 'vue';
import { abbreviateNumber } from '@/components/utils/core/number';

export default Vue.extend({
  name: 'WarRoomDealStoryHeaderFormatter',
  props: {
    author: {
      type: String,
      required: true,
    },
    withAuthorLink: {
      type: Boolean,
      default: true,
    },
    company: {
      type: String,
      default: '',
    },
    amount: {
      type: [Number, String],
      required: true,
    },
    departments: {
      type: Array,
      default: () => [],
    },
    secondaryColor: {
      type: String,
      default: '#797B86',
    },
  },
  computed: {
    amountAbbreviated(): string {
      return abbreviateNumber(Number(this.amount));
    },
    profileUrl(): string {
      return `/war-room/profile/${this.author}`;
    },
  },
});
